module.exports = __webpack_public_path__ + "img/bus.5c01a08e.svg";